import { createQueue } from "./deps.js";
export function createFilterQueue(predicate) {
    const queue = createQueue();
    return {
        ...queue,
        add(value) {
            if (predicate(value)) {
                queue.add(value);
            }
        },
    };
}
//# sourceMappingURL=queue.js.map